import ProductCarouselComponent from './components/ProductCarouselComponent';

window.addEventListener('vue-init', () => {
    mountVueComponent('product-carousel', ProductCarouselComponent);
})

if (typeof(mountVueComponent) == 'function') {
    mountVueComponent('product-carousel', ProductCarouselComponent);
}

